<template>
  <div class="travel-page">
    <q-layout class="bg-grey-1">
      <q-header elevated class="bg-teal-6 text-white" style="background: #009587" height-hint="61.59">
        <q-toolbar class="q-py-sm q-px-md travel-menu">
          <q-btn dense :icon="navLeftIcon" @click="$store.commit('helpers/toggleLefPanel')"/>

          <!--          <q-toolbar-title>-->
          <a style="text-decoration: none" flat v-html="topLogo" class="navbar-brand" href="/spa3/#/dashboard"/>

          <!--          </q-toolbar-title>-->
          <template v-if="isWindowSize('sm',true)">
            <q-btn
                v-for="(mainOption,idx) in flatenedMenu"
                :icon-right="mainOption.children?.length?'arrow_drop_down':null"
                color="secondary" class="bg-teal-7 text-white" :label="mainOption.label" :key="idx" unelevated square
                @click="mainOption.url&&!mainOption.children?.length?goto(mainOption.url):null">
              <q-menu v-if="mainOption.children?.length" class="bg-teal-7 text-white" square>
                <q-list style="min-width: 100px">
                  <q-item clickable v-close-popup v-for="(msOpt,idx) in mainOption.children" :key="idx"
                          :href="msOpt.url" class="bg-teal-7 text-white">
                    <q-item-section>{{ msOpt.label }}</q-item-section>
                  </q-item>
                </q-list>
              </q-menu>
            </q-btn>
            <!--            <q-space></q-space>-->
          </template>
          <template v-else>
            <q-space></q-space>
            <q-btn @click="floatMenu=!floatMenu" flat round icon="menu"></q-btn>
          </template>
        </q-toolbar>
      </q-header>
      <q-page-container style="display: flex;width:100%">
        <q-page class="travel-body">
          <slot>

          </slot>
        </q-page>
      </q-page-container>
    </q-layout>
    <q-dialog v-model="floatMenu" persistent
              :maximized="true"
              transition-show="slide-down"
              transition-hide="slide-up">
      <q-card class="bg-teal-7 text-white">
        <q-card-section class="row items-center q-pb-none">
          <div class="text-h6"></div>
          <q-space/>
          <q-btn icon="close" flat round dense v-close-popup/>
        </q-card-section>

        <q-list style="min-width: 100px" class="bg-teal-7 text-white" dark padding bordered>
          <template
              v-for="(mainOption,idx) in menu.options"
          >
            <template v-if="mainOption.url&&!mainOption.children?.length">
              <q-btn
                  xstyle="width: 100vw;padding: 4px"
                  color="secondary" class="bg-teal-7 text-white" :label="mainOption.label" :key="idx" unelevated
                  square
                  @click="goto(mainOption.url)"/>
            </template>
            <template v-else>
              <q-expansion-item
                  class="bg-teal-7 text-white"
                  :label="mainOption.label" :key="idx"
              >
                <q-list class="bg-grey-9">
                  <q-item clickable v-close-popup v-for="(msOpt,idx) in mainOption.children" :key="idx"
                          :href="msOpt.url" class="bg-teal-7 text-white">
                    <q-item-section>{{ msOpt.label }}</q-item-section>
                  </q-item>

                </q-list>
              </q-expansion-item>

            </template>
          </template>
        </q-list>
      </q-card>
    </q-dialog>
  </div>
</template>
<script>
export default {
  name: "BasicPage",
  data() {
    return {
      menu: window.TravelMenu,
      floatMenu: false
    };
  },
  methods: {
    goto(url) {
      _log_('menu', this.menu)
      window.location.href = url
    }
  },
  computed: {

    flatenedMenu() {
      const o = this.menu.options.map(mo => {
        if (mo?.children?.length === 1)
          mo = mo.children[0]
        return mo
      })
      return o
    },
    topLogo() {
      return this.menu?.logo || this.$userProfile.userDomain;
    },
    key() {
      return this.$route.fullPath;
    }
  }
};
</script>
<style scoped>
.travel-menu .q-btn {
  padding: 4px 16px;
}

.travel-body {
  width: 100%;
  flex-grow: 1;
  //height: calc(100vh - 65px);
  overflow: auto;

}

.caret {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 2px;
  vertical-align: middle;
  border-top: 4px dashed;
  border-top: 4px solid \9;
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
}

b, strong {
  font-weight: 700;
}
</style>